import { BearerTokenGetterContext } from '@pelckmans/business-components/context/BearerTokenGetterContext';
import { ErrorHandlerContext } from '@pelckmans/business-components/context/ErrorHandlerContext';
import { MiniDialogModal as MiniDialogModalUIComp } from '@pelckmans/business-components/components/mini-dialog-modal';
import { MiniDialogModalTranslationsContext } from '@pelckmans/business-components/context/MiniDialogModalTranslationsContext';

import { useContext } from 'react';
import getAccessToken from '../../../api/BearerToken';
import ModalContext from '../../../contexts/ModalContext';
import useRouting from '../../../hooks/useRouting';
import useThrowAsyncError from '../../../hooks/useThrowAsyncError';
import { useTranslation } from 'react-i18next';
import { MiniDialogMedialink } from '../_api/MedialinksApi';
import { Module } from '../_api/ModuleApi';

const getTranslations = ({
  t,
  r,
}: Pick<ReturnType<typeof useTranslation>, 't'> & Pick<ReturnType<typeof useRouting>, 'r'>) => ({
  closeDialog: t('ACTIONS.CLOSE'),
  generalNode: t('TOC_GENERAL'),
  playDialog: t('MODULES.MATERIAL.COMPONENTS.MINI_DIALOGS.PLAY_ENTIRE_DIALOG'),
  stopDialog: t('MODULES.MATERIAL.COMPONENTS.MINI_DIALOGS.STOP_DIALOG'),
  example: t('MODULES.MATERIAL.COMPONENTS.MINI_DIALOGS.EXAMPLE'),
  ownVoice: t('MODULES.MATERIAL.COMPONENTS.MINI_DIALOGS.OWN_VOICE'),
  optionsTextAndSound: t('MODULES.MATERIAL.COMPONENTS.MINI_DIALOGS.OPTIONS_TEXT_AND_SOUND'),
  optionsKeyWords: t('MODULES.MATERIAL.COMPONENTS.MINI_DIALOGS.OPTIONS_CORE_WORDS'),
  playTitle: t('MODULES.MATERIAL.COMPONENTS.MINI_DIALOGS.PLAY_TITLE'),
  pauseTitle: t('MODULES.MATERIAL.COMPONENTS.MINI_DIALOGS.PAUSE_TITLE'),
  recordTitle: t('MODULES.MATERIAL.COMPONENTS.MINI_DIALOGS.RECORD_TITLE'),
  stopRecordTitle: t('MODULES.MATERIAL.COMPONENTS.MINI_DIALOGS.STOP_RECORD_TITLE'),
  playRecordingTitle: t('MODULES.MATERIAL.COMPONENTS.MINI_DIALOGS.PLAY_RECORDING_TITLE'),
  pauseRecordingTitle: t('MODULES.MATERIAL.COMPONENTS.MINI_DIALOGS.PAUSE_RECORDING_TITLE'),
  hideTextTitle: t('MODULES.MATERIAL.COMPONENTS.MINI_DIALOGS.HIDE_TEXT_TITLE'),
  showTextTitle: t('MODULES.MATERIAL.COMPONENTS.MINI_DIALOGS.SHOW_TEXT_TITLE'),
  hideKeywordsTitle: t('MODULES.MATERIAL.COMPONENTS.MINI_DIALOGS.HIDE_KEYWORDS_TITLE'),
  showKeywordsTitle: t('MODULES.MATERIAL.COMPONENTS.MINI_DIALOGS.SHOW_KEYWORDS_TITLE'),
  muteTitle: t('MODULES.MATERIAL.COMPONENTS.MINI_DIALOGS.MUTE_TITLE'),
  unmuteTitle: t('MODULES.MATERIAL.COMPONENTS.MINI_DIALOGS.UNMUTE_TITLE'),
  errors: {
    browserSupport: t('COMPONENTS.NOTIFICATION_BAR.RECORD_RTC.NO_RECORD_RTC_SUPPORTED', { faqURL: r('helpdesk') }),
    accessDenied: t('COMPONENTS.NOTIFICATION_BAR.RECORD_RTC.NO_PERMISSION_GIVEN', { faqURL: r('helpdesk') }),
    noMicrophone: t('COMPONENTS.NOTIFICATION_BAR.RECORD_RTC.NO_MIC_FOUND'),
  },
});

type Props = {
  id: string;
  medialink: MiniDialogMedialink;
  module: Module;
};

export default function MiniDialogModal({ id, medialink, module }: Props) {
  const handleError = useThrowAsyncError();
  const { t } = useTranslation();
  const { r } = useRouting();

  const { closeModal } = useContext(ModalContext);

  return (
    <ErrorHandlerContext.Provider value={handleError}>
      <BearerTokenGetterContext.Provider value={getAccessToken}>
        <MiniDialogModalTranslationsContext.Provider value={getTranslations({ t, r })}>
          <MiniDialogModalUIComp
            mediaLink={medialink}
            onClose={() => closeModal(id)}
            superModuleHasExerciseEntrance={module.hasExerciseEntrance}
            urlPrefix={process.env.REACT_APP_P_API_URL}
            studioGroup={process.env.REACT_APP_P_STUDIO_GROUP}
          />
        </MiniDialogModalTranslationsContext.Provider>
      </BearerTokenGetterContext.Provider>
    </ErrorHandlerContext.Provider>
  );
}
